function toggleDescription(sectionId) {
    const content = document.getElementById(`DescContent-${sectionId}`);
    const btn = document.getElementById(`DescToggle-${sectionId}`);
    const showText = btn.getAttribute('data-show');
    const hideText = btn.getAttribute('data-hide');

    if (!content || !btn) return;

    if (content.classList.contains('collapsed')) {
        content.classList.remove('collapsed');
        btn.innerText = hideText;
    } else {
        content.classList.add('collapsed');
        btn.innerText = showText;
    }
}

const initDescriptionToggle = () => {
    const sectionEls = document.querySelectorAll('[data-section]');

    sectionEls.forEach(el => {
        const sectionId = el.getAttribute('data-section');
        const descContent = document.getElementById(`DescContent-${sectionId}`);
        const descBtn = document.getElementById(`DescToggle-${sectionId}`);

        if (!descContent || !descBtn) return;

        const contentHeight = descContent.scrollHeight;
        const threshold = 320; // must match CSS max-height

        if (contentHeight > threshold) {
            descContent.classList.add('collapsed');
            descBtn.style.display = 'inline-block';
        } else {
            descBtn.style.display = 'none';
        }
    });
};

window.blObjects.runFunction(initDescriptionToggle);
